import { useQuery } from '@tanstack/react-query';
import api from '@/lib/axios';

async function fetchDashboardSummary() {
  const { data } = await api.get('/api/dashboard/summary');
  return data;
}

export function useDashboardSummary() {
  return useQuery({
    queryKey: ['dashboard', 'summary'],
    queryFn: fetchDashboardSummary,
    staleTime: 60_000,
    retry: 1,
  });
}
